import { useAppSelector } from 'state/hooks';

import { useDayInfo } from 'features/task_bar/DatePicker';

import { useGetTimelineSummaryQuery } from '../../state/apiSlice';
import {
  selectComparison,
  selectProject,
  selectTargetDate,
} from '../../state/workflowSlice';
import { isComparisonMonth } from '../task_bar/ComparisonPicker';

export function useActivityTimeseries() {
  const targetDate = useAppSelector(selectTargetDate);
  const comparison = useAppSelector(selectComparison);
  const project_slug = useAppSelector(selectProject);
  const { day_info } = useDayInfo();
  const {
    currentData: timelineMetrics,
    isFetching,
    isLoading,
  } = useGetTimelineSummaryQuery(
    {
      project_slug,
      date: targetDate,
      typicalMonth: isComparisonMonth(comparison) ? comparison : undefined,
    },
    { skip: !project_slug || !targetDate || !day_info?.is_nrt },
  );

  let timeseries = timelineMetrics?.typRelCongestion;
  // if (timelineMetrics) {
  //   if ([TL_METRIC_ABS_SPEED].includes(timelineMetric)) {
  //     timeseries = timelineMetrics.avgCongestion;
  //   } else if ([TL_METRIC_TYP_REL_SPEED].includes(timelineMetric)) {
  //     timeseries = timelineMetrics.typRelCongestion;
  //   } else if ([TL_METRIC_ABS_VOL, TL_METRIC_TYP_REL_VOL].includes(timelineMetric)) {
  //     timeseries = timelineMetrics.typRelCounts;
  //   } else if ([TL_METRIC_TYP_REL_SPEED_VOL, TL_METRIC_FF_REL_SPEED_VOL].includes(timelineMetric)) {
  //     timeseries = timelineMetrics.typRelVhd;
  //   } else {
  //     timeseries = timelineMetrics.typRelVhd;
  //   }
  // }

  if (timeseries) {
    timeseries = [...timeseries];
    // Normalise the array
    const max = Math.max(...timeseries);
    const min = Math.min(...timeseries);
    for (let j = 0; j < timeseries.length; j++) {
      timeseries[j] -= min;
      timeseries[j] /= max - min;
    }
  }

  return { timeseries, isFetching, isLoading };
}
